const Loader = () => {
    return (
        <div role="status" className="d-flex justify-content-center align-items-center position-absolute w-100 h-100">
            <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    );
}

export default Loader;
